<rt-select
  [hasSearch]="false"
  [includeEmptyOption]="false"
  [value]="value"
  [options]="options"
  [placeholder]="'app.pricing.slots_counter.select_placeholder' | translate"
  [noMaxHeight]="true"
  (valueChange)="slotsChange.emit($event)"
></rt-select>
